export default __webpack_public_path__ + "static/media/back.4bce487b.jpg";